import { create } from "zustand";

export const usePropertyStore = create((set, get) => ({
  // State
  selectedProperty: null,
  properties: [],
  isLoading: false,
  extractedPdfData: null,
  error: null,
  filters: {
    agentId: null,
    status: null,
  },

  // Actions
  setSelectedProperty: (property) => set({ selectedProperty: property }),

  setProperties: (properties) => set({ properties }),

  setLoading: (isLoading) => set({ isLoading }),

  setExtractedPdfData: (extractedPdfData) => set({ extractedPdfData }),

  setError: (error) => set({ error }),

  setFilters: (filters) => set({ filters: { ...get().filters, ...filters } }),

  clearSelectedProperty: () => set({ selectedProperty: null }),

  clearFilters: () => set({ filters: { agentId: null, status: null } }),

  // Computed
  getFilteredProperties: () => {
    const { properties, filters } = get();
    return properties.filter((property) => {
      if (filters.agentId && property.agentId !== filters.agentId) return false;
      if (filters.status && property.status !== filters.status) return false;
      return true;
    });
  },

  getSelectedPropertyLeads: () => {
    const { selectedProperty, properties } = get();
    if (!selectedProperty) return [];
    const property = properties.find((p) => p.id === selectedProperty.id);
    return property?.leads || [];
  },
}));
